export default {
  bcn: {
    additionalDisplayOrderMethods: {
      ratings: "Notes ESG",
    },
  },
  demo: {
    customSections: {
      useCases: {
        title: "Cas d'usage",
        alpinum: {
          strategyName: "Alpinum",
          title: "Alpinum",
          historicalResults: {
            title: "Résultats historiques",
            biggestDrawdowns: {
              title: (ctx) => `Plus grands drawdowns de ${ctx.named("benchmark")}`,
            },
            drawdowns: {
              title: "Drawdowns",
            },
          },
          metaInfo: {
            title: "Cas d'Usage - Alpinum",
          },
          parameters: {
            runButton: "Exécuter cas d'usage",
            benchmark: "Benchmark",
            title: "Paramètres",
          },
        },
      },
    },
  },
  bcf: {
    redirectButtonNavBarText: "Retour à l'accueil",
  },
  bonhote: {
    redirectButtonNavBarText: "Retour à l'accueil",
    categories: {
      portfolios: "Portefeuilles modèles prévoyance",
    },
  },
  calmgard: {
    nextSubscriptionAndRedemption: {
      nextRedemption: (ctx) =>
        `<b>Les rachats</b> effectués avant le ${ctx.named(
          "date"
        )} à 12h00 CET seront exécutés au dernier VNI de ${ctx.named("month")}.`,
      nextSubscription: (ctx) =>
        `<b>Les souscriptions</b> effectués avant le ${ctx.named(
          "date"
        )} à 12h00 CET seront exécutés au dernier VNI de ${ctx.named("month")}.`,
      title: "Prochaines dates possibles de trading",
    },
  },
  citeGestion: {
    categories: {
      assetAllocationProducts: "Produits d'allocation d'actifs",
      etfPortfolios: "Portefeuilles modèles ETF",
      fundPortfolios: "Portefeuilles modèles Fonds",
      documents: "Documents",
    },
  },
  cronos: {
    redirectButtonNavBarText: "Page d'accueil Cronos",
  },
  mirante: {
    redirectButtonNavBarText: "Page d'accueil MFM",
  },
};
